import type { LoginFormSchema } from '@/modules/login/components/LoginForm/LoginForm.types'

export const loginFormDefaultValues: LoginFormSchema = {
  email: '',
  password: '',
}
